<div class="alert-box site-paid-features-modal">
    <div class="content-wrapper">
        <div class="modal-header">
            <button type="button" class="close" (click)="onCancel()" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">{{ "site_paid_features_modal_title" | translate }}</h4>
        </div>

        <div class="modal-body">
            <ul class="features-list">
                <li>{{ "site_paid_features_modal_feature_1" | translate }}</li>
                <li>{{ "site_paid_features_modal_feature_2" | translate }}</li>
                <li>{{ "site_paid_features_modal_feature_3" | translate }}</li>
                <li>{{ "site_paid_features_modal_feature_4" | translate }}</li>
                <li>{{ "site_paid_features_modal_feature_5" | translate }}</li>
                <li>{{ "site_paid_features_modal_feature_6" | translate }}</li>
            </ul>

            <a
                href="https://login.sendpulse.com/landing-pages/plans"
                target="_blank"
                class="btn btn-block btn-paid"
                (click)="onCancel()"
                >{{ "site_paid_features_modal_upgrade_btn" | translate }}
                <span class="sp-icon small-xs icon-outgoing"></span
            ></a>
        </div>
    </div>
    <div class="banner-wrapper"></div>
</div>
